module.exports = __webpack_public_path__ + "static/media/disabled.a94904c0.png";